export default function ({ store, redirect }) {
	if (!store.getters["isAuthenticated"]) {
		return redirect("/")
	}
	const user = store.state.user
	if (user && user.status === "disabled") {
		return redirect("/")
	}
}
